import { TranslateFunction } from '@pancakeswap/localization'
import { SalesSectionProps } from '.'

export const swapSectionData = (t: TranslateFunction): SalesSectionProps => ({
  headingText: t('Trade anything. No registration, no hassle.'),
  bodyText: t('Trade any token on Polygon Matic Chain in seconds, just by connecting your wallet.'),
  reverse: false,
  primaryButton: {
    to: '/swap',
    text: t('Trade Now'),
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.plaxswap.io/',
    text: t('Learn'),
    external: true,
  },
  images: {
    path: '/images/home/trade/',
    attributes: [
      { src: 'MATIC', alt: t('MATIC token') },
      { src: 'BTC', alt: t('BTC token') },
      { src: 'PLAX', alt: t('PLAX token') },
    ],
  },
})

export const earnSectionData = (t: TranslateFunction): SalesSectionProps => ({
  headingText: t('Earn passive income with crypto.'),
  bodyText: t('PlaxSwap makes it easy to make your crypto work for you.'),
  reverse: true,
  primaryButton: {
    to: '/farms',
    text: t('Explore'),
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.plaxswap.io/products/yield-farming',
    text: t('Learn'),
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: t('Pie chart') },
      { src: 'stonks', alt: t('Stocks chart') },
      { src: 'folder', alt: t('Folder with cake token') },
    ],
  },
})

export const cakeSectionData = (t: TranslateFunction): SalesSectionProps => ({
  headingText: t('PLAX makes our world go round.'),
  bodyText: t(
    'PLAX token is at the heart of the PlaxSwap ecosystem. Buy it, win it, farm it, spend it, stake it... heck, you can even vote with it!',
  ),
  reverse: false,
  primaryButton: {
    to: '/swap?outputCurrency=0x328801B0b580eAdd83eA841638865eA41Dc6fb25&chainId=137',
    text: t('Buy PLAX'),
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.plaxswap.io/tokenomic',
    text: t('Learn'),
    external: true,
  },

  images: {
    path: '/images/home/cake/',
    attributes: [
      { src: 'bottom-right-mini', alt: t('Small 3d robot') },
      { src: 'top-right-mini', alt: t('Small 3d robot') },
      { src: 'coin-plax', alt: t('PLAX token') },
      { src: 'top-left-mini', alt: t('Small 3d robot') },
    ],
  },
})
